import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary-fallback">
          <div className="bg-white border border-slate-200 rounded-2xl p-8 max-w-md text-center shadow-sm">
            <h1 className="text-xl font-bold text-slate-900 mb-2">Une erreur d'affichage est survenue</h1>
            <p className="text-sm text-slate-500 mb-6">
              Vos données et vos contrats sont en sécurité. Rechargez la page pour continuer.
            </p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
              className="inline-flex items-center justify-center bg-slate-900 text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-slate-800 transition-colors duration-150"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
